import * as React from 'react'

export const ClasslinkButton = ({isSignUp = false}) => {
  if (!window.postbuildEnv.CLASSLINK_ENABLED) { return <span /> }
  const actionText = isSignUp ? 'Sign up' : 'Log in'

  const handleClasslinkClick = () => {
    const baseUrl = 'https://launchpad.classlink.com/oauth2/v2/auth'
    const urlEncodedRedirectUrl = encodeURIComponent(`${window.postbuildEnv.DEFAULT_URL}/auth/classlink/callback`)
    const clientId = window.postbuildEnv.CLASSLINK_SSO_CLIENT_ID
    const signinMethod = isSignUp ? 'signup' : 'login'
    const state = `&state=${signinMethod}`
    const fullUrl = `${baseUrl}?scope=full&redirect_uri=${urlEncodedRedirectUrl}&client_id=${clientId}&response_type=code${state}`
    window.location.href = fullUrl
  }

  return (
    <button onClick={handleClasslinkClick} type="button">
      <img
        alt="ClassLink icon"
        className="classlink-icon"
        src={`${window.postbuildEnv.CDN_URL}/images/shared/classlink_icon_sm.png`}
      />
      <span>{actionText} with ClassLink</span>
    </button>
  )
}

export default ClasslinkButton;

